import type { i18n } from 'i18next'

export const isLanguageSupported = (i18n: i18n, lang?: string) => {
  return lang !== undefined && Array.isArray(i18n.options.supportedLngs) && i18n.options.supportedLngs.includes(lang)
}
